import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import abstractReducer from "../slices/abstractSlice";
import paymentReducer from "../slices/paymentSlice";
import cartReducer from '../slices/cartSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { encryptTransform } from 'redux-persist-transform-encrypt';

// Create the encryption transform
const encryptor = encryptTransform({
  secretKey: process.env.REACT_APP_SECRET_KEY,
  onError: (error) => console.error('Encryption Error:', error),
});

// Persist configuration
const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['auth', 'abstract', 'payment', 'cart'],
  transforms: [encryptor],
};

// Combine reducers (keeping all slices intact)
const rootReducer = combineReducers({
  auth: authReducer, // Handles authentication data
  abstract: abstractReducer, // Handles abstract-related data
  payment: paymentReducer, // Handles payment-related data
  cart: cartReducer, // Handles cart-related data
});

// Apply persistence to the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Export persistor and store
export const persistor = persistStore(store);
export default store;
